import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import "../assets/css/style.css";
import L from "leaflet";
import { motion, AnimatePresence } from "framer-motion";
import { useAuth } from "../context/AuthContext";
import "leaflet/dist/leaflet.css";
import { registrarTap } from "../api";
import { obtenerDetalleEvento } from "../api";
import "leaflet-gesture-handling/dist/leaflet-gesture-handling.css";
import "leaflet-gesture-handling";

const Evento = () => {
    const navigate = useNavigate();
    const [cargando, setCargando] = useState(true);
    const [bannerCargado, setBannerCargado] = useState(false);
    const [mostrarTextoCompleto, setMostrarTextoCompleto] = useState(false);
    const [evento, setEvento] = useState(null);
    const { id_evento } = useParams();
    const { user } = useAuth();
    const mapRef = useRef(null);
    const [hideHeader, setHideHeader] = useState(false);

    useEffect(() => {
        document.body.style.overflowY = 'auto';
        document.body.style.height = 'auto';
        document.documentElement.style.overflowY = 'auto';
        document.documentElement.style.height = 'auto';

        const handleScroll = () => {
            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            if (scrollTop > 50) {
                setHideHeader(true);
            } else {
                setHideHeader(false);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            document.body.style.overflowY = 'hidden';
            document.body.style.height = '100vh';
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);   
    
    const abrirEnlace = (tipo, url, idEvento) => {
      const id_perfil = localStorage.getItem("id_perfil");
      registrarTap(0, 'evento', '', idEvento);
      if (window.flutter_inappwebview) {
        window.flutter_inappwebview.callHandler("abrirEnlaceExterno", url);
      } else {
        window.open(url, "_blank");
      }
    };
    
    useEffect(() => {
        if (user === undefined) return;
      
        const fetchEvento = async () => {
          try {
            const data = await obtenerDetalleEvento(id_evento, user?.id || null);
            if (data.success) {
              setEvento({
                ...data.evento,
                itinerario: data.itinerario || [],
              });
              const timer = setTimeout(() => {
                setCargando(false);
                document.body.style.overflow = "auto";
              }, 3000);
      
              return () => clearTimeout(timer);
            } else {
              console.error("❌ Error en la API:", data.error);
            }
          } catch (err) {
            console.error("❌ Error al obtener datos del evento:", err);
          }
        };
      
        fetchEvento();
      }, [id_evento, user]);    


      const formatearFecha = (fechaStr) => {
        const fecha = new Date(fechaStr);
        const opciones = { day: "2-digit", month: "short", year: "numeric" };
        const fechaFormateada = fecha.toLocaleDateString("es-ES", opciones);
        const partes = fechaFormateada.split(" ");
        const dia = partes[0];
        const mes = partes[1].charAt(0).toUpperCase() + partes[1].slice(1);
        const anio = partes[2];
        return `${dia} ${mes}, ${anio}`;
    };

    const formatearHoraExacta = (fechaStr) => {
      if (!fechaStr || typeof fechaStr !== "string") return "Hora inválida";
      let horaTxt = "";
      if (fechaStr.includes("T")) {
          horaTxt = fechaStr.split("T")[1]?.split(":");
      } else if (fechaStr.includes(" ")) {
          horaTxt = fechaStr.split(" ")[1]?.split(":");
      }
      if (!horaTxt || horaTxt.length < 2) return "Hora inválida";
      const [h, m] = horaTxt.map(Number);
      if (isNaN(h) || isNaN(m)) return "Hora inválida";
      const offset = -4;
      const horaLocal = (h + offset + 24) % 24;
      const ampm = horaLocal >= 12 ? "PM" : "AM";
      const hora12 = horaLocal % 12 === 0 ? 12 : horaLocal % 12;
      const minutos = m.toString().padStart(2, "0");
      return `${hora12}:${minutos} ${ampm}`;
    };

    useEffect(() => {
        if (cargando || !evento?.latitud || !evento?.longitud || !mapRef.current) return;
      
        const latitud = parseFloat(evento.latitud);
        const longitud = parseFloat(evento.longitud);
      
        if (mapRef.current && mapRef.current.innerHTML !== "") {
          mapRef.current.innerHTML = "";
        }
      
        if (!L.Map.prototype._gestureHandlingHookAdded) {
          L.Map.addInitHook("addHandler", "gestureHandling", L.GestureHandling);
          L.Map.prototype._gestureHandlingHookAdded = true;
        }
      
        const map = L.map(mapRef.current, {
          center: [latitud, longitud],
          zoom: 17,
          minZoom: 15,
          maxZoom: 20,
          zoomControl: true,
          gestureHandling: true,
        });
      
        L.tileLayer(
          "https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png",
          {
            attribution: '&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a>',
          }
        ).addTo(map);
      
        const customIcon = L.divIcon({
            className: 'pulse-wrapper',
            html: `<div class="pulse-icon" style="background-image: url('${evento.portada}')"></div>`,
            iconSize: [45, 45],
            iconAnchor: [22, 45],
            popupAnchor: [0, -40],
          });
      
        L.marker([latitud, longitud], { icon: customIcon })
          .addTo(map)
          .bindPopup(evento.lugar)
          .openPopup();
      
        return () => {
          map.remove();
        };
    }, [cargando, evento]);

    if (cargando || !evento) {
        return (
        <div id="splash">
            <img src="/assets/images/loading.gif" loading="lazy" style={{ width: 300 }} alt="Cargando..." />
        </div>
        );
    }

  return (
    <>
      {cargando && (
        <div id="splash">
          <img src="/assets/images/loading.gif" loading="lazy" style={{ width: 300 }} alt="Cargando..." />
        </div>
      )}
      {!cargando && (
       <motion.div
	      initial={{ y: "100%", opacity: 0 }}
	      animate={{ y: 0, opacity: 1 }}
	      exit={{ y: "100%", opacity: 0 }}
	      transition={{ duration: 0.7, ease: "easeInOut" }}
    	>
        <div className="ticket-container">
          <div className="ticket-header">
          <div className="back-container" style={{marginTop:'10px'}}>
            <button className="back-btn" style={{background:'white', color:'black'}} onClick={() => navigate("/eventos")}>
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 512 512">
                <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="48" d="M244 400L100 256l144-144M120 256h292" />
              </svg>
            </button>
          </div>
          </div>
      <div className="ticket-content">
        <img src={evento.portada} loading="lazy" alt="Promoción" onLoad={() => setBannerCargado(true)} onError={() => setBannerCargado(true)} style={{ opacity: bannerCargado ? 1 : 0 }} className="ticket-image" />
        <div className="ticket-details">
          <h3 className="event-title">{evento.titulo}</h3>
          <p className="event-location">
            <svg width="15" height="15" viewBox="0 0 24 24">
                <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
                  <path d="M12.56 20.82a.96.96 0 0 1-1.12 0C6.611 17.378 1.486 10.298 6.667 5.182A7.6 7.6 0 0 1 12 3c2 0 3.919.785 5.333 2.181c5.181 5.116.056 12.196-4.773 15.64"></path>
                  <path d="M12 12a2 2 0 1 0 0-4a2 2 0 0 0 0 4"></path>
                </g>
              </svg>
              {evento.lugar} ({evento.direccion}).
          </p>
          <div className="recomendaste" style={{marginTop:-15, marginBottom:15}}>
              <span>
                {evento?.tipo === 1
                  ? "El ingreso a este evento podría tener cargos"
                  : "El ingreso a este evento es GRATUITO"}
              </span>
          </div>
          <div className="ticket-info">
            <div className="info-block">
              <p className="label">Fecha</p>
              <p className="value">{formatearFecha(evento.fecha)}</p>
            </div>
            <div className="info-block">
              <p className="label">Hora</p>
              <p className="value">{formatearHoraExacta(evento.fecha)}</p>
            </div>
            <div className="info-block">
              <p className="label">Organiza</p>
              <p className="value">{evento.organizador}.</p>
            </div>
          </div>
            <div className="qr-section" style={{textAlign:"left"}}>
              <b>Detalles:</b>
              <div style={{ paddingTop:15, fontSize: 14, color: "#333", marginBottom:10, borderBottom:'1px solid #eee'}} dangerouslySetInnerHTML={{ __html: evento.descripcion }}>
              </div>
            </div>
              
            <div className="itinerary-container">
            <b style={{textAlign:"left",paddingBottom:25, display:"block"}}>Itinerario del evento:</b>
            {evento?.itinerario?.length > 0 && evento.itinerario.map((item, index) => (
                <div className="itinerary-item" key={item.id_cronograma}>
                  <div className="time-icon">
                    <div className="icon-check">
                      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24">
                        <path fill="currentColor" fillRule="evenodd" d="M12 21a9 9 0 1 0 0-18a9 9 0 0 0 0 18m-.232-5.36l5-6l-1.536-1.28l-4.3 5.159l-2.225-2.226l-1.414 1.414l3 3l.774.774z" clipRule="evenodd" />
                      </svg>
                    </div>
                    {index !== evento.itinerario.length - 1 && <div className="vertical-line"></div>}
                  </div>
                  <div className="itinerary-content">
                    <div className="time">{item.hora.substring(0, 5)}</div>
                    <div className="title">{item.descripcion}</div>
                  </div>
                </div>
              ))}
            </div>
          <div className="qr-section" style={{textAlign:"left", paddingTop:0}}>
            <b style={{display:'block', paddingBottom:'10px'}}>¿Dónde será?:</b>
            <div
                id="map"
                ref={mapRef}
                style={{
                    height: "200px",
                    width: "100%",
                    borderRadius: "10px"
                }}
                ></div>
          </div>
          <div className="qr-section" style={{textAlign:"left"}}>
            <b style={{display:'block', paddingTop:'10px'}}>¿Cómo llegar?:</b>
            <div className="opciones-horizontal" style={{gap:5, paddingBottom:20}}>
              <div className="opcion" style={{flex:'0 0 40%'}} onClick={() => abrirEnlace("waze", `https://waze.com/ul?ll=${evento.latitud},${evento.longitud}&navigate=yes`, evento.id_evento)}>
                <p>Ir con Waze</p>
                <div className="icono-circulo">
                  <img src="/assets/images/waze.png" alt="Waze" />
                </div>
              </div>

              <div className="opcion" style={{flex:'0 0 40%'}} onClick={() => abrirEnlace("maps", `https://www.google.com/maps/dir/?api=1&destination=${evento.latitud},${evento.longitud}`, evento.id_evento)}>
                <p>Ir con Google Maps</p>
                <div className="icono-circulo">
                  <img src="/assets/images/maps.png" alt="Google Maps" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </motion.div>
    )}
    </>
  );
};

export default Evento;